import React from 'react';
import { Button } from '../../../components/ui/Button';
import { SoonPill } from './SoonPill';

const Row = ({ title, description, soon, children }) => (
  <div className="flex flex-wrap items-center justify-between gap-4 pt-6 first:pt-0">
    <div>
      <h4 className="text-sm font-bold text-ninja-dark dark:text-white mb-1 flex items-center gap-2">
        {title}
        {soon && <SoonPill />}
      </h4>
      <p className="text-sm text-text-secondary">{description}</p>
    </div>
    {children}
  </div>
);

/**
 * Password, and the two things that look like security features but are not
 * built.
 *
 * The mockup carried "Ultima vez cambiada: Hace 45 dias" and "2 dispositivos
 * conectados". Both are gone: the API exposes neither a password timestamp nor
 * a session list, and an invented number in a security panel is the worst place
 * to put one — it reads as an audit trail.
 *
 * @param {object} props
 * @param {() => void} props.onChangePassword
 * @param {(title: string) => void} props.onComingSoon
 */
export const SecurityCard = ({ onChangePassword, onComingSoon }) => (
  <div className="bg-white dark:bg-[#1a1a1a] rounded-2xl p-8 shadow-sm border border-border">
    <div className="mb-6">
      <h3 className="text-lg font-bold text-ninja-dark dark:text-white">Seguridad</h3>
      <p className="text-sm text-text-secondary mt-1">
        Configura tu contraseña y métodos de verificación
      </p>
    </div>

    <div className="space-y-6 divide-y divide-border">
      <Row
        title="Contraseña"
        description="Te enviaremos un código a tu correo para confirmar que eres tú."
      >
        <Button variant="ghost" onClick={onChangePassword}>
          Cambiar Contraseña
        </Button>
      </Row>

      <Row
        title="Verificación en dos pasos"
        description="Agrega una capa extra de seguridad a tu cuenta."
        soon
      >
        <Button variant="ghost" onClick={() => onComingSoon('Verificación en dos pasos')}>
          Configurar
        </Button>
      </Row>

      <Row
        title="Sesiones activas"
        description="Revisa desde qué dispositivos entraste y cierra los que no reconozcas."
        soon
      >
        <Button variant="ghost" onClick={() => onComingSoon('Sesiones activas')}>
          Ver Sesiones
        </Button>
      </Row>
    </div>
  </div>
);
